import { render } from "./EditDistributionCenter.vue?vue&type=template&id=3af9443e"
import script from "./EditDistributionCenter.vue?vue&type=script&lang=js"
export * from "./EditDistributionCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__